import corNeutraChip from "./corNeutraChip";

// Catálogo de status de versão -> tokens de cor do theme (fundo/texto), pelos literais exatos que o backend devolve
const statusVersao = (theme) => ({
	Atualizado: {
		background: theme.palette.chip.background.success,
		color: theme.palette.chip.colorText.success,
	},
	Desatualizado: {
		background: theme.palette.chip.background.high,
		color: theme.palette.chip.colorText.high,
	},
	"À frente do padrão": {
		background: theme.palette.chip.background.info,
		color: theme.palette.chip.colorText.info,
	},
	"Só no cliente": {
		background: theme.palette.chip.background.low,
		color: theme.palette.chip.colorText.low,
	},
	"Ausente no cliente": corNeutraChip(theme),
	"Sem versão": corNeutraChip(theme),
});

export default statusVersao;
